var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('s-table',{ref:"table",attrs:{"size":"default","columns":_vm.columns,"data":_vm.loadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }